import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, purple } from '../colors';

export const newColor = (mode: PaletteMode): ChronosphereColorPalette => {
  return mode === 'light'
    ? {
        main: purple[500],
        highContrast: purple[700],
        lowContrast: purple[100],
      }
    : {
        main: purple[400],
        highContrast: purple[100],
        lowContrast: purple[800],
      };
};
